import 'angular';

import '../api/api.module';
import '../core/core.module.ajs';
import '../grids/grids.module';
import '../messages/messages.module.ajs';

import { downgradeInjectable } from '@angular/upgrade/static';

import { ProductBomItemsLiteCtrl }      from './product.bom-items';
import { ProductBranchStockLiteCtrl }   from './product.branch-stock';
import { ProductGroupQuickAddLiteCtrl } from './product-group.quick-add';
import { ProductLiteCtrl }              from './product';
import { ProductSearchCellCtrl }        from './product-search.cell';
import { ProductSearchCellDirective }   from './product-search.cell.directive';
import { ProductSearchService }         from './product.search.service';
import { ProductService }               from './product.service';
import { ProductsLiteCtrl }             from './products';

angular.module('app-lite.products', [
  'app-lite.api',
  'app-lite.core',
  'app-lite.grids',
  'app-lite.messages'
]).controller('ProductBomItemsLiteCtrl', ProductBomItemsLiteCtrl)
  .controller('ProductBranchStockLiteCtrl', ProductBranchStockLiteCtrl)
  .controller('ProductGroupQuickAddLiteCtrl', ProductGroupQuickAddLiteCtrl)
  .controller('ProductLiteCtrl', ProductLiteCtrl)
  .controller('ProductSearchCellCtrl', ProductSearchCellCtrl)
  .controller('ProductsLiteCtrl', ProductsLiteCtrl)
  .directive('productSearchCell', ProductSearchCellDirective)
  .service('productApi', downgradeInjectable(ProductService))
  .service('productSearchApi', downgradeInjectable(ProductSearchService));
